export var ContainerLayout;
(function (ContainerLayout) {
    /** Two equal columns (50/50) from lgMin (1200px). Stacked below. */
    ContainerLayout["Equal"] = "EQUAL";
    /** Two equal columns (50/50) from lgMin (1200px) until the first reaches 750px, then 750px + flexible second. Stacked below lgMin. */
    ContainerLayout["EqualWide"] = "EQUAL_WIDE";
    /** Fixed sidebar on the left (300px, 750px from 2561px) + flexible main column. Side-by-side at all widths. */
    ContainerLayout["SidebarLeft"] = "SIDEBAR_LEFT";
    /** Flexible main column + fixed 300px sidebar on the right. Same at all breakpoints. */
    ContainerLayout["SidebarRight"] = "SIDEBAR_RIGHT";
})(ContainerLayout || (ContainerLayout = {}));
